import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { authService } from '../services/api';
import { getCookie } from '../utils/cookies';

const GuestRoute = ({ children }) => {
	const [checking, setChecking] = useState(true);
	const [redirectTo, setRedirectTo] = useState(null);

	useEffect(() => {
		const checkAuth = async () => {
			const token = getCookie('token');

			if (!token) {
				setChecking(false);
				return;
			}

			try {
				const response = await authService.whoAmI();

				if (response.success && response.data) {
					localStorage.setItem('user', JSON.stringify(response.data));
					// Admin → /admin/dashboard, user thường → /
					setRedirectTo(response.data.role === 'admin' ? '/admin/dashboard' : '/');
				}
			} catch (error) {
				// Token không hợp lệ, cho phép vào trang guest
			} finally {
				setChecking(false);
			}
		};

		checkAuth();
	}, []);

	if (checking) {
		return (
			<Box
				sx={ {
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					minHeight: '100vh',
				} }
			>
				<CircularProgress />
			</Box>
		);
	}

	// Đã đăng nhập → redirect đúng trang theo role
	if (redirectTo) {
		return <Navigate to={ redirectTo } replace />;
	}

	return children;
};

export default GuestRoute;
